module.exports = __webpack_public_path__ + "static/media/secure.642f264a.png";